import { MARKDOWN_IMAGE_PATTERN } from './textUtils';

export const handleDownload = async (url: string, filename: string) => {
  try {
    const response = await fetch(url);
    if (response.ok) {
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

      return;
    }
  } catch {
    // Silently fall back to direct download
  }

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getFileName = (url: string): string => {
  try {
    const urlObj = new URL(url);
    const { pathname } = urlObj;
    const filename = pathname.split('/').pop();

    return filename || 'download';
  } catch {
    return 'download';
  }
};

export const extractFileUrlFromContent = (content: string | unknown, fileName?: string): string | null => {
  if (typeof content !== 'string') {
    return null;
  }

  const imageMatch = content.match(MARKDOWN_IMAGE_PATTERN);
  if (imageMatch && imageMatch[2]) {
    return imageMatch[2];
  }

  const linkMatch = content.match(/\[([^\]]+)\]\(([^)]+)\)/);
  if (linkMatch && linkMatch[2]) {
    if (fileName && linkMatch[2].includes(fileName)) {
      return linkMatch[2];
    }
    if (!fileName) {
      return linkMatch[2];
    }
  }

  return null;
};
